// JavaScript Document - map-svg.js

// 1. Basic state name map
const STATE_NAMES = {
  AL:"Alabama", AK:"Alaska", AZ:"Arizona", AR:"Arkansas", CA:"California", CO:"Colorado", CT:"Connecticut", DE:"Delaware",
  FL:"Florida", GA:"Georgia", HI:"Hawaii", ID:"Idaho", IL:"Illinois", IN:"Indiana", IA:"Iowa", KS:"Kansas", KY:"Kentucky",
  LA:"Louisiana", ME:"Maine", MD:"Maryland", MA:"Massachusetts", MI:"Michigan", MN:"Minnesota", MS:"Mississippi", MO:"Missouri",
  MT:"Montana", NE:"Nebraska", NV:"Nevada", NH:"New Hampshire", NJ:"New Jersey", NM:"New Mexico", NY:"New York",
  NC:"North Carolina", ND:"North Dakota", OH:"Ohio", OK:"Oklahoma", OR:"Oregon", PA:"Pennsylvania", RI:"Rhode Island",
  SC:"South Carolina", SD:"South Dakota", TN:"Tennessee", TX:"Texas", UT:"Utah", VT:"Vermont", VA:"Virginia",
  WA:"Washington", WV:"West Virginia", WI:"Wisconsin", WY:"Wyoming", DC:"District of Columbia"
};

// ROUTE FROM LANDING TO SELECTED STATE ON FYO PAGE
// USE IF STATE LINKS AREN'T WORKING -- const OFFICIALS_PAGE_URL = "https://statementfashion.us/pages/find-your-officials";
const OFFICIALS_PAGE_URL = "https://statementfashion.us/pages/find-your-government-representatives-and-elected-officials";

// 2. Elements Mapping
const mapShell = document.getElementById("mapShell");
const svgHost = document.getElementById("svgHost");
const tooltip = document.getElementById("tooltip");
const ttTitle = document.getElementById("ttTitle");
const ttBody = document.getElementById("ttBody");
const clearBtn = document.getElementById("clearBtn");
const stateSelect = document.getElementById("stateSelect");

let activeEl = null;
let rafMove = 0;

// 3. Tooltip Helpers
function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

function showTooltip(stateCode, clientX, clientY) {
  const name = STATE_NAMES[stateCode] || stateCode;
  ttTitle.textContent = `${name} (${stateCode})`;
  ttBody.textContent = `Click to view representatives for ${name}.`;

  const shellRect = mapShell.getBoundingClientRect();
  const pad = 10;
  tooltip.classList.add("is-visible");

  const tipRect = tooltip.getBoundingClientRect();
  let x = clientX - shellRect.left + 14;
  let y = clientY - shellRect.top + 14;

  x = clamp(x, pad, shellRect.width - tipRect.width - pad);
  y = clamp(y, pad, shellRect.height - tipRect.height - pad);

  tooltip.style.left = x + "px";
  tooltip.style.top = y + "px";
}

function hideTooltip() {
  tooltip.classList.remove("is-visible");
}

// 4. THE CORE RENDERER
function renderDetails(stateCode) {
  const stateName = STATE_NAMES[stateCode] || stateCode;

  // TOGGLE VISIBILITY: Show results, hide instruction box
  const blankState = document.getElementById('fyo-blank-state');
  const dataRows = document.getElementById('fyo-active-results');
  if (blankState) blankState.style.display = 'none';
  if (dataRows) dataRows.style.display = 'block';

  // Update Heading
  const heading = document.getElementById("fyoResultsHeading");
  if (heading) heading.textContent = `${stateName} Officials`;

  // Sync state image/logic (fmo.js)
  if (typeof handleStateClick === 'function') {
    handleStateClick(stateName);
  }

  // Clear Carousels
  const fedCarousel = document.getElementById("federal-carousel");
  const stateCarousel = document.getElementById("state-carousel");
  if (fedCarousel) fedCarousel.innerHTML = '';
  if (stateCarousel) stateCarousel.innerHTML = '';

  // Load Data
  if (typeof loadStateData === 'function') {
    loadStateData(stateCode);
  }

  // Scroll to Results 
  //const resultsSection = document.getElementById("results");
  //if (resultsSection) resultsSection.scrollIntoView({ behavior: 'smooth' });

  if (clearBtn) clearBtn.disabled = false;
}

// 5. Interaction Logic
function setActive(el) {
  if (activeEl && activeEl !== el) activeEl.classList.remove("is-active");
  activeEl = el;
  if (activeEl) activeEl.classList.add("is-active");
}

function makeStateInteractive(el) {
  const id = (el.getAttribute("id") || "").trim();
  if (!id || id.length < 2) return;

  el.setAttribute("role", "link");
  el.setAttribute("tabindex", "0");
  el.setAttribute("aria-label", STATE_NAMES[id] ? `${STATE_NAMES[id]} (${id})` : id);

  // COMMENTING OUT TOOLTIPS BECAUSE I WANT TO CRAWL IN A HOLE AND DIE
  el.addEventListener("mouseenter", (e) => showTooltip(id, e.clientX, e.clientY));
  el.addEventListener("mousemove", (e) => {
    if (rafMove) return;
    rafMove = requestAnimationFrame(() => {
      rafMove = 0;
      showTooltip(id, e.clientX, e.clientY);
    });
  });
  el.addEventListener("mouseleave", hideTooltip);

    el.addEventListener("click", (e) => {
    // 1. Look directly up the tree from the clicked state to find the map container
    const mapContainer = el.closest('[data-us-map]');
    
    // 2. Check if that specific container has the landing class
    const isLanding = mapContainer && mapContainer.classList.contains('map-is-landing');

    if (isLanding) {
      window.location.href = `${OFFICIALS_PAGE_URL}?state=${id}#results`;
      return;
    }
    
    // 3. Normal behavior for the results page
    setActive(el);
    if (stateSelect) stateSelect.value = id; 
    renderDetails(id);
  });
}

// 6. Initialization
const NAME_TO_CODE = Object.fromEntries(
  Object.entries(STATE_NAMES).map(([code, name]) => [name.toLowerCase(), code])
);

function init() {
  // Use a more specific selector to find your new map
  const svg = document.getElementById("svg56") || svgHost.querySelector("svg");
  if (!svg) return;

  // Only target the actual state paths, ignoring the "decor" islands
  const shapes = svg.querySelectorAll("path.state"); 
  
  shapes.forEach((shape) => {
    if (shape.dataset.wired === "1") return;

    // Force the script to find the title even if the path was slightly malformed
    const t = shape.querySelector("title");
    if (t) {
      const name = t.textContent.trim().toLowerCase();
      const code = NAME_TO_CODE[name];
      if (code) {
        shape.id = code; // This turns 'path2' into 'FL'
      }
    }

    // Now that the ID is set correctly to 'FL', 'TX', etc., wire it up
    if (shape.id && (shape.id.length === 2 || shape.id === "DC")) {
      makeStateInteractive(shape);
      shape.dataset.wired = "1";
    }
  });

  // Dropdown Listener 
  if (stateSelect) {
    stateSelect.addEventListener('change', (e) => {
      const code = e.target.value;
      if (code) {
        const shape = document.getElementById(code);
        if (shape) setActive(shape);
        renderDetails(code);
      }
    });
  }
}


/* THIS GOES WITH ORIGINAL US MAP 
const NAME_TO_CODE = Object.fromEntries(
  Object.entries(STATE_NAMES).map(([code, name]) => [name.toLowerCase(), code])
);

function init() {
  const svg = svgHost.querySelector("svg");
  if (!svg) return;

  const shapes = svg.querySelectorAll("path, circle");
  shapes.forEach((shape) => {
    if (shape.dataset.wired === "1") return;

    if (!shape.id) {
      const t = shape.querySelector("title");
      const name = t ? t.textContent.trim().toLowerCase() : "";
      const code = NAME_TO_CODE[name];
      if (code) shape.id = code;
    }

    if (shape.id && (shape.id.length === 2 || shape.id === "DC")) {
      makeStateInteractive(shape);
      shape.dataset.wired = "1";
    }
  });

  // Dropdown Listener (Green Circle Fix)
  if (stateSelect) {
    stateSelect.addEventListener('change', (e) => {
      const code = e.target.value;
      if (code) {
        const shape = document.getElementById(code);
        if (shape) setActive(shape);
        renderDetails(code);
      }
    });
  }
} */

// 7. Clear Button logic
function clearDetails() {
  if (activeEl) activeEl.classList.remove("is-active");
  activeEl = null;

  // TOGGLE VISIBILITY: Reset to blank state
  const blankState = document.getElementById('fyo-instruction-box');
  const dataRows = document.getElementById('fyo-active-results');
  if (blankState) blankState.style.display = 'block';
  if (dataRows) dataRows.style.display = 'none';

  // Reset Heading & Dropdown
  const heading = document.getElementById("fyoResultsHeading");
  if (heading) heading.textContent = "Officials by State";
  if (stateSelect) stateSelect.value = "";

  // Clear Carousels
  const fedC = document.getElementById("federal-carousel");
  const stateC = document.getElementById("state-carousel");
  if (fedC) fedC.innerHTML = '';
  if (stateC) stateC.innerHTML = '';

  // Reset Image Placeholder
  const imgElement = document.getElementById('state-image-display');
  if (imgElement && window.asset_url_base) {
    imgElement.src = window.asset_url_base + "state-Placeholder.png";
  }

  if (clearBtn) clearBtn.disabled = true;
}

if (clearBtn) {
  clearBtn.addEventListener("click", clearDetails);
}

init();